<template>
    <div class="grow">
        <!-- When there are no pins to show. -->
        <PinsEmptyState v-if="!searchIsLoading && drawer.pins.length === 0" />
        <!-- All items in this tray. -->
        <div class="pb-6 px-6">
            <div v-if="searchIsLoading" class="space-y-4">
                <PinItemSkeleton v-for="i in [1,2,3]" />
            </div>
            <ul v-else class="space-y-4">
                <PinItem v-for="pin in filteredPins" :pin="pin" />
            </ul>
            <div v-if="computedInput.length && !filteredPins.length" class="flex items-center justify-center h-80">
                <PinSearchEmptyState :query="computedInput" />
            </div>
        </div>
    </div>
</template>

<script setup>
import {PinItem, PinItemSkeleton, PinSearchEmptyState, PinsEmptyState} from "@/Components";
import {usePinsDrawer} from "@/Composables";
import {computed} from "vue";

const { drawer, searchIsLoading } = usePinsDrawer();
const props = defineProps(['modelValue', 'sortValue']);

const computedInput = computed(() => props.modelValue);
const computedSortInput = computed(() => props.sortValue);

const filteredPins = computed(() => {
    // 1) pull in search & sort settings
    const term      = computedInput.value.trim().toLowerCase()
    const { field, direction } = computedSortInput.value.value

    // 2) clone the pins so we don’t reorder the source
    let list = drawer.value.pins.slice()

    // 3) apply search filter
    if (term) {
        list = list.filter(pin =>
            pin.name?.toLowerCase().includes(term)
        )
    }

    // 4) sort by the chosen field & direction
    list.sort((a, b) => {
        let aVal = a[field]
        let bVal = b[field]

        // parse dates if sorting on created_at
        if (field === 'created_at') {
            aVal = new Date(aVal)
            bVal = new Date(bVal)
        }

        // string compares
        if (typeof aVal === 'string' && typeof bVal === 'string') {
            const cmp = aVal.localeCompare(bVal)
            return direction === 'asc' ? cmp : -cmp
        }

        // date or numeric compares
        if (aVal instanceof Date && bVal instanceof Date) {
            const diff = aVal - bVal
            return direction === 'asc' ? diff : -diff
        }
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return direction === 'asc' ? aVal - bVal : bVal - aVal
        }

        return 0
    })

    return list
})
</script>
